import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';

@Component({
  selector: 'app-button-pill',
  templateUrl: './button-pill.component.html',
  styleUrls: ['./button-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton]
})
export class ButtonPillComponent {
  @Input() imageSrc: string;
  @Input() iconName: string;
  @Input() imageWidth: string;
  @Input() imageHeight: string;
  @Input() buttonText: string;
}
